module.exports = __webpack_public_path__ + "static/media/betaald_white.e8161347.svg";